export default {
  baseURL: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_URL : 'http://localhost:3030',
  bucketURL: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BUCKET_URL : 'https://agenda-homol.s3.us-east-2.amazonaws.com',
  contatoURL: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_CONTATO_URL : 'https://wa.me/554488423636?text=Ol%C3%A1!%20Quero%20saber%20mais%20sobre%20o%20Reservei%20Online',
  useFixture: false,
}
